import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { TtButton } from '@23/ui-react'

import { useConfirmationModal } from '../../../../../../../global/hooks/useConfirmationModal'

interface DeleteFieldConfirmationModalProps {
  onConfirm: () => void
  onCancel: () => void
}

const DeleteFieldConfirmation = ({
  onConfirm,
  onCancel,
}: DeleteFieldConfirmationModalProps) => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      <TtButton
        slot="footer"
        color="danger"
        pill
        onClick={() => {
          onConfirm()
          setIsLoading(true)
        }}
        loading={isLoading}
      >
        <FormattedMessage defaultMessage="Delete" />
      </TtButton>
      <TtButton
        slot="footer"
        color="secondary"
        variant="outline"
        pill
        disabled={isLoading}
        onClick={onCancel}
      >
        <FormattedMessage defaultMessage="Cancel" />
      </TtButton>
    </>
  )
}

const useOpenDeleteActionCardFieldConfirmationModal = () => {
  return useConfirmationModal(DeleteFieldConfirmation, {
    title: 'Are you sure you want to delete this field?',
  })
}

export { useOpenDeleteActionCardFieldConfirmationModal }
